<template>
  <div class="stub">
    <h1>{{ $t('page.NOT_FOUND') }}</h1>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

</style>
